import React, { Component } from 'react'
import FixedView from '../../components/FixedView'
import FormViewer from '../../components/FormViewer'
import SidebarView from '../../components/SidebarView'
import { translate } from '../../utils/useful'
import Collapsible from 'react-collapsible'



export default class StepTwo extends Component {
    state = {
        Accounts: [
            { title: "Outlook", icon: "/assets/icons/email/outlook.png" },
            { title: "microsoft", icon: "/assets/icons/email/microsoft.png" },
            { title: "Google", icon: "/assets/icons/email/google.png" },
            { title: "Yahoo", icon: "/assets/icons/email/yahoo.png" },
            // {title:"Yahoo",icon:"/assets/icons/email/yahoo.png"},
            // {title:"Yahoo",icon:"/assets/icons/email/yahoo.png"},
            // {title:"Yahoo",icon:"/assets/icons/email/yahoo.png"},
            { title: "iCloud", icon: "/assets/icons/email/icloud.png" },
        ],

        headers: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Name', placeholder: '{{lang}}John Applesed', required: true, }, showMain: false },
            { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Email', placeholder: '{{lang}}user@example.com', required: true, }, showMain: false },
            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Description', placeholder: '{{lang}}My Email Account', required: true, }, showMain: false },

        ],

        headers2: [
            { key: 'inbound.host', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Host Name', placeholder: '{{lang}}mail.example.com', required: true, }, showMain: false },
            { key: 'inbound.port', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Port', placeholder: '{{lang}}mail.Required', required: true, }, showMain: false },
            // { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.User Name', placeholder: '{{lang}}mail.Required', required: true, }, showMain: false },
            { key: 'inbound.security', type: 'SelectInput', col: '12', information: { label: '{{lang}}mail.Security', type: "local", placeholder: '{{lang}} Required', required: true, items: [{ value: 'STARTTLS', title: 'STARTTLS' }, { value: 'SSL/TLS', title: 'SSL/TLS' }, { value: '{{lang}}mail.None', title: '{{lang}}mail.None' }] }, showMain: false },
            // { key: 'password', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}mail.My Email Account', required: true, }, showMain: false },

        ],
        headers3: [
            { key: 'outbound.host', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Host Name', placeholder: '{{lang}}smtp.example.com', required: true, }, showMain: false },
            { key: 'outbound.port', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Port', placeholder: '{{lang}}mail.Required', required: true, }, showMain: false },
            // { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.User Name', placeholder: '{{lang}}mail.Required', required: false, }, showMain: false },
            { key: 'outbound.security', type: 'SelectInput', col: '12', information: { label: '{{lang}}mail.Security', type: "local", placeholder: '{{lang}}mail.Required', required: true, items: [{ value: 'STARTTLS', title: 'STARTTLS' }, { value: 'SSL/TLS', title: 'SSL/TLS' }, { value: '{{lang}}mail.None', title: '{{lang}}mail.None' }] }, showMain: false },
            // { key: 'password', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}mail.My Email Account', required: false, }, showMain: false },

        ],
        open: {
            incoming: true,
            outcoming: true
        },
    }



    openSidebar = () => {
        this.sidebarView.openSidebar()
    }
    submitMail = () => {
        let data = this.props.data
        let inboundData = this.inboundForm.getForm()
        let outboundData = this.outboundForm.getForm()

        if (inboundData && outboundData) {
            data = { ...data, ...inboundData, ...outboundData }
            this.props.setData('data', data, () => {
                this.props.addAccounts()
            })
        }
    }
    backStage = () => {
        this.props.changeStage('first')
    }
    openCollapsible = (key) => {
        let open = this.state.open
        open[key] = !open[key]
        this.setState({ open })

    }
    render() {
        return (
            <div className='h-100 scroll-no-scrollbar'>
                <div className='p-3 flexc' style={{ borderBottom: "1px solid #ddd" }}>
                    <button className='flexcc' onClick={() => this.backStage()}>
                        <img src='/assets/icons/arrow-left-blue.svg' />
                    </button>
                    <div className='flexcb w-100'>
                        <p className='font-size-18 weight-500'>{translate('mail.New Account')}</p>
                        <button className='blue-btn br-10 px-3 py-2' onClick={() => this.submitMail()}>
                            <p className='white font-size-14'>{translate('mail.Submit')}</p>
                        </button>
                    </div>
                </div>
                {/* <div className='pb-1 pt-4' style={{ borderBottom: "1px solid #ddd" }}>
                    <FormViewer ref={el => this.form = el} headers={this.state.headers} inputClass={"modern-input"} />
                </div> */}
                <div className='pt-3 pb-3 px-3 w-100' onClick={() => this.openCollapsible('incoming')}>
                    <p className='font-size-12' style={{ color: "#888", }}>{translate('mail.INCOMING EMAIL SERVER')}</p>
                </div>
                <Collapsible open={this.state.open.incoming}>
                    <div className='py-2' style={{ borderBottom: "1px solid #ddd" }}>
                        <FormViewer ref={el => this.inboundForm = el} initData={this.props.data} headers={this.state.headers2} inputClass={"modern-input"} />
                    </div>
                </Collapsible>
                <div className='pt-3 pb-3 px-3 w-100' onClick={() => this.openCollapsible('outcoming')}>
                    <p className='font-size-12' style={{ color: "#888", }}>{translate('mail.OUTGOING EMAIL SERVER')}</p>
                </div>
                <Collapsible open={this.state.open.outcoming}>
                    <div className='py-2'>
                        <FormViewer ref={el => this.outboundForm = el} initData={this.props.data}headers={this.state.headers3} inputClass={"modern-input"} />
                    </div>
                </Collapsible>
            </div>
        )
    }
}
